class StoreFinderAjaxLoader {
  filterElements = null;
  storeFinder = null;

  constructor() {
    this.findStoreFinder();
    if(document.querySelector('.jobmap')) this.changeMapOnFilter();
    this.consentBanner();
  }

  changeMapOnFilter = () => {
    let filter = document.querySelector('.jobmap-filter input[type="checkbox"]'),
        self = this;

    filter.addEventListener('change', Event => {
      setTimeout(() => {
        self.storeFinder.initializeLocation();
      }, 10);
    })
  }

  findStoreFinder() {
    window.requestAnimationFrame(this.waitForStoreFinder.bind(this));
  }

  waitForStoreFinder() {
    if (typeof window.StoreFinder !== 'undefined') {
      this.storeFinder = window.StoreFinder;
      this.storeFinder.previousCities = [];
      this.storeFinder.initializeLocation = this.loadLocationsViaAjax;
    } else {
      window.requestAnimationFrame(this.waitForStoreFinder.bind(this));
    }
  }

  loadLocationsViaAjax() {
    let endpoint = '/api/v1/de/locations',
      data = {
        position: [],
        skillLevel: [],
        checked: 0
      },
      filter = document.querySelector('.jobmap-filter input[type="checkbox"]');

    let cards = Array.from(document.querySelectorAll('.city-card'));
    cards.forEach((card) => {
      /**
       * @desc if city has no retrainings but only courses we have to toggle display when
       */
      if (card.classList.contains('no-retraining')) {
        card.style.display = filter.checked ? 'block' : 'none';
      }

      /**
       * @desc get city card subheader with open label for changing the counter from all / retrainings
       */
      let jobInfo = card.querySelector('.jobs-open-info');
      jobInfo.innerHTML = (filter.checked ? jobInfo.dataset.all : jobInfo.dataset.retraining) + ' Offene Stellen';

      /**
       * @desc toogle courses if checkbox changes
       * @type {unknown[]}
       */
      let courses = Array.from(card.querySelectorAll('.course'));
      if (courses.length > 0) {
        courses.forEach((course) => {
          course.style.display = filter.checked ? 'block' : 'none';
        });
      }
    });

    if (filter.checked) {
      data.checked = 1;
    } else {
      data.checked = 0;
    }

    $.ajax({
      url: endpoint,
      data: {
        tx_wmdtemplate_ajax: data
      }
    }).done((cities) => {

      /**
       * @desc toggle overlay if there is no map entry
       */
      if(cities.length === 0) {
        Array.from(document.querySelectorAll('.jobmap-map-overlay')).forEach(item => item.classList.remove('d-none'));
      } else {
        Array.from(document.querySelectorAll('.jobmap-map-overlay')).forEach(item => item.classList.add('d-none'));
      }

      let north = 0,
        south = 10000,
        east = 0,
        west = 10000;

      cities.forEach((city) => {
        north = Math.max(north, city.lat);
        south = Math.min(south, city.lat);
        east = Math.max(east, city.lng);
        west = Math.min(west, city.lng);
      });

      let northWest = new google.maps.LatLng(north, west),
        southEast = new google.maps.LatLng(south, east),
        bounds = new google.maps.LatLngBounds(northWest, southEast);

      this.infoWindow.close();

      this.previousCities.forEach((city) => {
        city.marker.setMap(null);
      });

      cities.forEach(this.processLocation.bind(this));

      this.previousCities = cities;

      if(cities.length !== 0) {
        this.map.fitBounds(bounds);
      }
    });
  }

  consentBanner() {
    let mapWrapper = document.getElementById('tx_storefinder_map');
    if (mapWrapper && mapWrapper.childNodes !== 0) {
      document.getElementById('tx_storefinder_map').innerHTML = `
            <div class="uc-embedding-container">
                <div class="uc-embedding-wrapper">
                    <h3>Wir benötigen Ihre Zustimmung, um den Google-Maps-Service zu laden!</h3>
                    <p class="description-text">
                        Wir verwenden einen Service eines Drittanbieters, um Karteninhalte einzubetten. Dieser Service kann
                        Daten zu Ihren Aktivitäten sammeln. Bitte lesen Sie die Details durch und stimmen Sie der Nutzung des
                        Service zu, um diese Karte anzuzeigen.
                    </p>
                    <div class="uc-embedding-buttons">
                        <button id="more-info" class="uc-embedding-more-info">
                            Mehr Informationen
                        </button>
                        <button id="consent" class="uc-embedding-accept">Akzeptieren</button>
                    </div>
                    <span>Powered by <a href="https://usercentrics.com/?utm_source=cmp&amp;utm_medium=powered_by" rel="nofollow" target="_blank">Usercentrics Consent Management</a></span>
                </div>
            </div>
            `;
    }

    const consent = document.getElementById('consent');
    const moreInfo = document.getElementById('more-info');

    if (consent !== null) {
      consent.addEventListener('click', function () {
        uc.ucapi.setConsents([{'templateId': 'S1pcEj_jZX', 'status': true}]);
        location.reload();
      });
    }
    if (moreInfo !== null) {
      moreInfo.addEventListener('click', function () {
        uc.ucapi.showInfoModal('S1pcEj_jZX');
        return false;
      });
    }
  }
}

new StoreFinderAjaxLoader();
